import { withDefaultProps } from '@aspectus/vue-utils';

import Table from './Table';
import TableBody from './TableBody';
import TableItem from './TableItem';
import SelectionTable from './SelectionTable';
import ExpandableTable from './ExpandableTable';
import OrderableTable from './OrderableTable';

const OrderableSelectionTable = withDefaultProps({ tableComponent: () => OrderableTable }, SelectionTable);
const FullFeaturedTable = withDefaultProps({ tableComponent: () => OrderableSelectionTable }, ExpandableTable);

function install(Vue) {
  Vue.component(Table.name, Table);
  Vue.component(TableBody.name, TableBody);
  Vue.component(TableItem.name, TableItem);
  Vue.component(SelectionTable.name, SelectionTable);
  Vue.component(ExpandableTable.name, ExpandableTable);
  Vue.component(OrderableTable.name, OrderableTable);

  Vue.component('vue-full-featured-table', FullFeaturedTable);
}

export default { install };
export * from './utils';
